module.exports = __webpack_public_path__ + "img/dashboard-sidebar-desktop-en.096026c1.jpg";